<form [formGroup]="createEmbedCodeFormGroup">
    <section class="sh-dialog__content">
        <h4 class="sh-clear-margin-top">{{ subtitle }}</h4>

        <sh-notification *ngIf="infoMessage$ | async as infoMessage" [type]="notificationType.Update" [message]="infoMessage" [icon]="'info'"></sh-notification>

        <ng-container *ngIf="showDimensionControls">
            <div class="sh-form-row">
                <sh-form-number-input [id]="'embed-width'" [label]="config.data.widthLabel" [min]="0" [control]="widthControl"></sh-form-number-input>

                <sh-form-number-input [id]="'embed-height'" [label]="config.data.heightLabel" [min]="0" [control]="heightControl"></sh-form-number-input>
            </div>
        </ng-container>

        <sh-form-checkbox
            *ngIf="showAutoplayControl"
            [id]="'embed-autoplay'"
            [label]="config.data.autoplayLabel"
            [control]="autoplayControl"
        ></sh-form-checkbox>

        <div class="sh-form-group">
            <code class="sh-form-group__input sh-wrap-text" [id]="'embed-code'">{{ embedCode$ | async }}</code>
        </div>
    </section>
    <footer class="sh-dialog__footer">
        <div class="sh-action-group -sh-align-end">
            <sh-copy-button
                [data]="embedCode$ | async"
                [label]="config.data.copyToClipboardLabel"
                [disabled]="buttonDisabled$ | async"
                [disabledMessage]="((disabledMessageKey$ | async) ?? '') | translate"
                (copySuccess)="copySuccess($event)"
                (copyFailure)="copyFailure($event)"
            >
            </sh-copy-button>
            <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ config.data.cancelLabel }}</button>
        </div>
    </footer>
</form>
